"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_LOCALE = exports.SUPPORTED_LOCALE_AND_REGION_LIST = exports.SUPPORTED_REGION_LOCALE_LIST = exports.SUPPORTED_LOCALE_LIST = exports.VI_VN = exports.VN = exports.ZH_TW = exports.TW = exports.TH_TH = exports.EN_TH = exports.TH = exports.EN_SG = exports.SG = exports.EN_NZ = exports.NZ = exports.MS_MY = exports.EN_MY = exports.ZH_MY = exports.MY = exports.KO_KR = exports.KR = exports.JA_JP = exports.JP = exports.ID_ID = exports.EN_ID = exports.ID = exports.EN_HK = exports.ZH_HK = exports.HK = exports.EN_AU = exports.AU = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _SUPPORTED_LOCALE_LIS, _SUPPORTED_REGION_LOC;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AU = 'au';
exports.AU = AU;
var EN_AU = 'en-au';
exports.EN_AU = EN_AU;
var HK = 'hk';
exports.HK = HK;
var ZH_HK = 'zh-hk';
exports.ZH_HK = ZH_HK;
var EN_HK = 'en-hk';
exports.EN_HK = EN_HK;
var ID = 'id';
exports.ID = ID;
var EN_ID = 'en-id';
exports.EN_ID = EN_ID;
var ID_ID = 'id-id';
exports.ID_ID = ID_ID;
var JP = 'jp';
exports.JP = JP;
var JA_JP = 'ja-jp';
exports.JA_JP = JA_JP;
var KR = 'kr';
exports.KR = KR;
var KO_KR = 'ko-kr';
exports.KO_KR = KO_KR;
var MY = 'my';
exports.MY = MY;
var ZH_MY = 'zh-my';
exports.ZH_MY = ZH_MY;
var EN_MY = 'en-my';
exports.EN_MY = EN_MY;
var MS_MY = 'ms-my';
exports.MS_MY = MS_MY;
var NZ = 'nz';
exports.NZ = NZ;
var EN_NZ = 'en-nz';
exports.EN_NZ = EN_NZ;
var SG = 'sg';
exports.SG = SG;
var EN_SG = 'en-sg';
exports.EN_SG = EN_SG;
var TH = 'th';
exports.TH = TH;
var EN_TH = 'en-th';
exports.EN_TH = EN_TH;
var TH_TH = 'th-th';
exports.TH_TH = TH_TH;
var TW = 'tw';
exports.TW = TW;
var ZH_TW = 'zh-tw';
exports.ZH_TW = ZH_TW;
var VN = 'vn';
exports.VN = VN;
var VI_VN = 'vi-vn';
exports.VI_VN = VI_VN;
var SUPPORTED_LOCALE_LIST = (_SUPPORTED_LOCALE_LIS = {}, (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, ZH_TW, ZH_TW), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, EN_HK, EN_HK), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, ZH_HK, ZH_HK), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, ZH_MY, ZH_MY), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, EN_MY, EN_MY), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, MS_MY, MS_MY), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, EN_ID, EN_ID), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, ID_ID, ID_ID), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, EN_SG, EN_SG), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, KO_KR, KO_KR), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, JA_JP, JA_JP), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, TH_TH, TH_TH), (0, _defineProperty2["default"])(_SUPPORTED_LOCALE_LIS, EN_TH, EN_TH), _SUPPORTED_LOCALE_LIS);
exports.SUPPORTED_LOCALE_LIST = SUPPORTED_LOCALE_LIST;
var SUPPORTED_REGION_LOCALE_LIST = (_SUPPORTED_REGION_LOC = {}, (0, _defineProperty2["default"])(_SUPPORTED_REGION_LOC, AU, EN_AU), (0, _defineProperty2["default"])(_SUPPORTED_REGION_LOC, HK, EN_HK), (0, _defineProperty2["default"])(_SUPPORTED_REGION_LOC, ID, ID_ID), (0, _defineProperty2["default"])(_SUPPORTED_REGION_LOC, JP, JA_JP), (0, _defineProperty2["default"])(_SUPPORTED_REGION_LOC, KR, KO_KR), (0, _defineProperty2["default"])(_SUPPORTED_REGION_LOC, MY, MS_MY), (0, _defineProperty2["default"])(_SUPPORTED_REGION_LOC, NZ, EN_NZ), (0, _defineProperty2["default"])(_SUPPORTED_REGION_LOC, SG, EN_SG), (0, _defineProperty2["default"])(_SUPPORTED_REGION_LOC, TH, TH_TH), (0, _defineProperty2["default"])(_SUPPORTED_REGION_LOC, VN, VI_VN), (0, _defineProperty2["default"])(_SUPPORTED_REGION_LOC, TW, ZH_TW), _SUPPORTED_REGION_LOC);
exports.SUPPORTED_REGION_LOCALE_LIST = SUPPORTED_REGION_LOCALE_LIST;

var SUPPORTED_LOCALE_AND_REGION_LIST = _objectSpread(_objectSpread({}, SUPPORTED_LOCALE_LIST), SUPPORTED_REGION_LOCALE_LIST);

exports.SUPPORTED_LOCALE_AND_REGION_LIST = SUPPORTED_LOCALE_AND_REGION_LIST;
var DEFAULT_LOCALE = EN_HK;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@snapask/common-components/dist/constants/locales.js
// module id = 56
// module chunks = 33